export default __webpack_public_path__ + "static/media/background.db07dcd1.jpg";